<div class="stepper">
  @for (step of steps; track step; let i = $index) {
  <div class="stepper-step" [ngClass]="statusFor(i + 1)">
    <div class="stepper-circle">
      @if (statusFor(i + 1) === 'done') {
      <ion-icon name="checkmark-outline" />
      } @else {
      <span>{{ i + 1 }}</span>
      }
    </div>
    <span class="stepper-label">{{ step }}</span>
  </div>
  @if (i < steps.length - 1) {
  <div class="stepper-connector" [ngClass]="statusFor(i + 1) === 'pending' ? 'pending' : 'done'"></div>
  }
  }
</div>
